<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="requestForm" :refresh-key="refreshTableKey" :show-expand="false" :set-api-data="setApiData">
        <template v-slot:tabs>
            <v-row>
                <v-col>
                    <v-btn-toggle mandatory class="ml-2 float-right" tile color="deep-purple accent-3" group>
                        <v-btn @click="toggleCompleted(false)"> Outstanding </v-btn>
                        <v-btn @click="toggleCompleted(true)"> Completed </v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
        </template>
        <template v-slot:buttons="{ item }">
            <v-btn v-if="hasClaim('CompleteRequests')" color="tertiary" dark class="mr-2" @click="markAsCompleted(item)">Mark as Completed</v-btn>
        </template>
    </table-base>
</template>

<script>
    import axios from 'axios'

    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                requestForm: () => import('../forms/RequestForm'),
                headers: [
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Message', value: 'message' },
                    { text: 'Requested On', value: 'requestedOn', format: this.formatDate },
                    { text: 'Completed On', value: 'completedOn', format: this.formatDate },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "requestedOn", direction: "descending" },
                    { column: "memberId", direction: "ascending" },
                ],
                itemsField: 'requests',
                editPageName: 'request',
                apiMethod: 'Requests',
                claimName: 'Requests',
                formTitle: 'Request',
                excelTitle: 'Requests',
                hasEditPage: false,

                displayCompleted: false,
                refreshTableKey: 0,
            }
        },

        methods: {
            async markAsCompleted(item) {
                await axios.put("/api/Requests/MarkAsCompleted/" + item.id);
                this.refreshTableKey += 1;
            },

            async toggleCompleted(displayCompleted) {
                this.displayCompleted = displayCompleted;
                this.refreshTableKey += 1;
            },

            setApiData(data) {
                this.$set(this.apiData, 'members', data.members);
                this.$set(this.apiData, 'items', data.items.filter(i => this.displayCompleted ? i.completedOn !== null : i.completedOn === null));
            }
        },
        watch: {
            refreshKey() {
                this.refreshTableKey += 1;
            }
        }
    };
</script>
